import { isNonEmpty } from '@sgme/fp';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import type { SecondaryMarketQuotesTabType } from 'state/workspaces/model';

type ToolbarProps = {
  children?: ReactNode;
  type: SecondaryMarketQuotesTabType;
  labels?: readonly (string | undefined)[];
};

const emptyLabels: readonly [] = [];
export const Toolbar: FC<ToolbarProps> = ({ type, labels = emptyLabels, children }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="d-flex flex-row bg-lvl1 w-100 align-items-center py-2 px-4">
      <div className="d-flex justify-content-center align-items-center border mx-2 p-2">
        <span className="fw-bold color-primary">{formatMessage({ id: `secondaryMarket.tabType.${type}` })}</span>
      </div>
      {labels.filter(isNonEmpty).map((label, idx) => (
        <div className="badge badge-default rounded-pill py-1 mx-2" key={idx}>
          {label}
        </div>
      ))}
      <div className="ms-auto">{children}</div>
    </div>
  );
};
